// src/redux/classificationSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";
import { useEffect } from "react";

// Async thunk for fetching the classifications list
export const fetchClassificationsList = createAsyncThunk(
  "classifications/fetchClassificationsList",
  async () => {
    const response = await axios.post(apiurl + "classifications_list");
    return response.data.data; // Return the data to be used in the slice
  }
);

const initialState = {
  classifications: [],
  loading:false,
  status: "idle", 
  error: null,
};



const classificationSlice = createSlice({
  name: "classifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassificationsList.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchClassificationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.classifications = action.payload;
      })
      .addCase(fetchClassificationsList.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default classificationSlice.reducer;



